import React from "react"
import { Box, Flex, Grid, Heading, Text, Container } from "@theme-ui/components"
import RichContentStructuredText from "../richContentStructuredText"
import { GatsbyImage } from "gatsby-plugin-image"
import { number } from "prop-types"

const SimpleImageAndText = ({
  title,
  body,
  image,
  description,
  label,
  subtitle,
  rightAligned,
}) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Grid
        columns={[1, 1, 2]}
        gap={[0, 0, 0]}
        sx={{ py: [0, 0, 7], position: "relative" }}
      >
        <Flex
          sx={{
            flexDirection: "column",
            py: [0],
            pr: [0,7],
          }}
        >
          <Box>
            <Heading as="div" variant="sectionTitle">
              <Box as="h2" variant="h2">{title}</Box>
            </Heading>
          </Box>
          <Box>
            <Text sx={{pb:[6]}}  dangerouslySetInnerHTML={{ __html : description}}/>
          </Box>
        </Flex>
        <Box
          sx={{
            position: ["relative"],
            width: ["100%"],
          }}
        >
          <Box
            sx={{
              position: ["relative"],
              width: ["100%"],
              ".gatsby-image-wrapper": {
                width: "100%",
              },
            }}
          >
            <GatsbyImage image={image.gatsbyImageData} alt="" />
          </Box>
        </Box>
      </Grid>
    </Box>
  )
}

export default SimpleImageAndText
